import {
	Box,
	Button,
	Checkbox,
	ClickAwayListener,
	Divider,
	FormControlLabel,
	FormGroup,
	List,
	Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import FilterListIcon from '@mui/icons-material/FilterList';
import { useState } from 'react';
import { useBoundStore } from 'useStore';
import LightTooltip from 'views/Components/Shared/Components/LightTooltip';
import useMarketplacesForCurrentCountry from 'views/Components/Shared/hooks/useMarketplacesForCurrentCountry';

function Options({ closeTooltip, marketplaces }) {
	const selectedMarketplace = useBoundStore(
		(state) => state.fhSelectedMarketplace
	);
	const setSelectedMarketplace = useBoundStore(
		(state) => state.setFhSelectedMarketplace
	);
	const resetSelectedMarketplace = useBoundStore(
		(state) => state.resetFhSelectedMarketplace
	);

	const handleClearFilters = () => {
		resetSelectedMarketplace();
	};

	return (
		<List
			sx={{ width: '340px', maxWidth: 340, bgcolor: 'background.paper' }}
			component="nav"
			aria-labelledby="nested-list-subheader"
			subheader={
				<Stack
					direction="row"
					spacing={3}
					alignItems="center"
					justifyContent="space-between"
				>
					<Typography
						sx={{
							pl: 2,
							color: 'rgba(0, 0, 0, 0.87)',
							fontFamily: 'Roboto',
							fontStyle: 'normal',
							fontSize: '16px',
							lineHeight: '24px',
							fontWeight: '700',
							letterSpacing: '0.15px',
						}}
					>
						Filtrar por:
					</Typography>
					<Button
						color="secondary"
						onClick={handleClearFilters}
						disabled={selectedMarketplace === 1}
					>
						Limpiar filtro
					</Button>
				</Stack>
			}
		>
			<Divider />

			<List component="div" disablePadding>
				<Box
					sx={{
						maxHeight: '200px',
						overflowY: 'auto',
					}}
				>
					<FormGroup sx={{ pl: 2 }}>
						{/* <FormControlLabel
							control={
								<Checkbox
									color="secondary"
									checked={selectedMarketplace === 0}
									onChange={() => {
										setSelectedMarketplace(selectedMarketplace === 0 ? 1 : 0);
									}}
								/>
							}
							label="Todos"
						/> */}
						{marketplaces.map((marketplace) => (
							<FormControlLabel
								key={marketplace.marketplace_id}
								control={
									<Checkbox
										color="secondary"
										checked={selectedMarketplace === marketplace.marketplace_id}
										onChange={() => {
											selectedMarketplace === marketplace.marketplace_id
												? resetSelectedMarketplace()
												: setSelectedMarketplace(marketplace.marketplace_id);
										}}
									/>
								}
								label={marketplace.marketplace_sname}
							/>
						))}
					</FormGroup>
				</Box>
			</List>

			<Divider />

			<Button
				color="secondary"
				onClick={closeTooltip}
				sx={{
					mt: 2,
				}}
			>
				Cerrar
			</Button>
		</List>
	);
}

export default function MarketplaceFilter() {
	const marketplacesForCurrentCountry = useMarketplacesForCurrentCountry();

	const [open, setOpen] = useState(false);

	const handleTooltipClose = () => {
		setOpen(false);
	};

	const handleToggleTooltip = () => {
		setOpen((prev) => !prev);
	};

	return (
		<ClickAwayListener onClickAway={handleTooltipClose}>
			<div>
				<LightTooltip
					PopperProps={{
						disablePortal: true,
					}}
					onClose={handleTooltipClose}
					open={open}
					disableFocusListener
					disableHoverListener
					disableTouchListener
					title={
						<Options
							closeTooltip={handleTooltipClose}
							marketplaces={marketplacesForCurrentCountry}
						/>
					}
				>
					<Stack
						direction="row"
						alignItems="center"
						justifyContent="space-between"
						sx={{
							padding: '12px',
							width: '182px',
							borderRadius: '4px',
							border: '1px solid rgba(0, 0, 0, 0.23)',
							cursor: 'pointer',
						}}
						onClick={handleToggleTooltip}
					>
						<Typography
							sx={{
								color: '#00000099',
								fontSize: '16px',
								fontFamily: 'Roboto',
								fontStyle: 'normal',
								fontWeight: '400',
								lineHeight: '24px',
								letterSpacing: '0.15px',
							}}
						>
							Canal
						</Typography>
						<FilterListIcon
							sx={{
								fill: '#0000008F',
								width: '24px',
								height: '24px',
							}}
						/>
					</Stack>
				</LightTooltip>
			</div>
		</ClickAwayListener>
	);
}
